const FloatingLabel = ({ htmlFor, labelText, className = "" }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-1.5 scale-75 top-4 z-10 origin-[0] start-3
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0
                     peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-gray-600 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto ${className}`}
    >
      {labelText}
    </label>
  );
};

export default FloatingLabel;
